module.exports = __webpack_public_path__ + "img/697-f3c2af.png";